import { useState } from 'react';
import {
  Button, TextField, Link, Grid2 as Grid, Typography, Select, FormHelperText,
  FormControl, MenuItem, OutlinedInput, InputAdornment, IconButton, InputLabel,
  FormControlLabel, FormGroup, Checkbox,
} from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { useNavigate } from 'react-router-dom';
import ArrowDropDownCircleIcon from '@mui/icons-material/ArrowDropDownCircle';

import { checkEmail } from '../../actions/users';
import { isEmpty } from '../common/helpers';

const SignUp = () => {
  const infoInput = {
    username: '',
    email: '',
    tel: '',
    pass: '',
    confirmarPass: '',
    prefijo: '52',
    politicas: '',
    terminos: ''
  }
  const [data, setData] = useState(infoInput);
  const [disable, setDisable] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfimPassword, setShowConfimPassword] = useState(false);
  const [error, setError] = useState(infoInput);
  const [aceptarTerms, setAceptarTerms] = useState(false);
  const [aceptarPolit, setAceptarPolit] = useState(false);
  const navigate = useNavigate();

  const cambiar = e => {
    setData({
      ...data,
      [e.target.name]: e.target.value
    });
  };

  const guardar = async e => {
    e.preventDefault();
    const arrError = {};
    if (isEmpty(data.username)) {
      arrError.username = "Ingrese un nombre de usuario";
    }
    if (isEmpty(data.email)) {
      arrError.email = "Ingrese un email";
    }
    const validateEmail = data.email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);

    if (!validateEmail) {
      arrError.email = "Debe ser un email válido";
    }
    let check = await checkEmail(data.email);
    if (check) {
      return setError({
        email: "El email ya existe"
      });
    }

    if (isEmpty(data.tel) || data.tel.length != 10) {
      arrError.tel = "Debe de poner un teléfono con 10 digitos";
    }

    if (isEmpty(data.pass) || data.pass.length < 6) {
      arrError.pass = "Ingresa una contraseña con al menos 6 caracteres";
    }

    if (data.pass !== data.confirmarPass) {
      arrError.pass = "No coincide las contraseñas",
        arrError.confirmarPass = "No coincide las contraseñas"
    }

    if (!aceptarPolit) {
      arrError.politicas = "Acepta la política de privacidad";
    }

    if (!aceptarTerms) {
      arrError.terminos = "Acepta los términos y condiciones";
    }

    if (Object.keys(arrError).length >= 1 || (!isEmpty(arrError.terminos) || !isEmpty(arrError.politicas))) {
      return setError(arrError);
    }
    setDisable(true);

    const info = data;
    info.terminos = aceptarTerms;
    info.politicas = aceptarPolit;
    info.num = data.prefijo + data.tel
    navigate('/signup-step', { state: { info } })
  }

  return (
    <Grid className="form form-sign" size={{ lg: 6 }}>
      <form noValidate onSubmit={guardar}>
        <Grid className="content-form" container sx={{ my: 2 }}>
          <Grid container direction="column" alignItems="center" justifyContent="center" >
            <Typography variant="h3" component="h3">Crear cuenta</Typography>
          </Grid>
          <Grid size={12} mb={1}>
            <TextField
              className="input-sigup"
              error={isEmpty(error.username) ? false : true}
              required
              fullWidth
              id="username"
              label="Nombre de usuario"
              name="username"
              value={data.username}
              onChange={cambiar}
              helperText={!isEmpty(error.username) && error.username}
            />
          </Grid>
          <Grid size={12} mb={1}>
            <TextField
              className="input-sigup"
              error={isEmpty(error.email) ? false : true}
              required
              fullWidth
              id="email"
              label="Email"
              name="email"
              autoComplete="email"
              value={data.email}
              onChange={cambiar}
              helperText={!isEmpty(error.email) && error.email}
            />
          </Grid>
          <Grid size={{ xs: 5, md: 4 }} mb={1}>
            <FormControl sx={{ width: "100%" }}>
              <Select
                autoWidth
                name="prefijo"
                className="input-sigup"
                value={data.prefijo}
                onChange={cambiar}
                IconComponent={() => <ArrowDropDownCircleIcon color="primary" />}
              >
                <MenuItem value="52">
                  <img alt="México" width="25" src="/mexico.png" /> +52
                </MenuItem>
                <MenuItem value="1">
                  <img alt="EEUU" width="20" src="/eeuu.png" /> +1
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid size={{ xs: 7, md: 8 }} pl={1}>
            <TextField
              error={isEmpty(error.tel) ? false : true}
              variant="outlined"
              required
              fullWidth
              id="tel"
              label="Número celular"
              type='number'
              name="tel"
              value={data.tel}
              onChange={cambiar}
              helperText={!isEmpty(error.tel) && error.tel}
            />
          </Grid>
          <Grid size={12} mb={1}>
            <FormControl sx={{ width: "100%" }} variant="outlined">
              <InputLabel htmlFor="outlined-adornment-password">
                Contraseña
              </InputLabel>
              <OutlinedInput
                id="outlined-adornment-password"
                type={showPassword ? "text" : "password"}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={() => setShowPassword(!showPassword)}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                }
                error={isEmpty(error.pass) ? false : true}
                label="Contraseña"
                name="pass"
                value={data.pass}
                onChange={cambiar}
              />
              <FormHelperText error={isEmpty(error.pass) ? false : true}>
                {!isEmpty(error.pass) && error.pass}
              </FormHelperText>
            </FormControl>
          </Grid>
          <Grid size={12}>
            <FormControl sx={{ width: "100%" }} variant="outlined">
              <InputLabel
                htmlFor="outlined-adornment-password"
              >
                Confirmar contraseña
              </InputLabel>
              <OutlinedInput
                id="outlined-adornment-password"
                type={showConfimPassword ? "text" : "password"}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={() => setShowConfimPassword(!showConfimPassword)}
                      edge="end"
                    >
                      {showConfimPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                }
                error={isEmpty(error.confirmarPass) ? false : true}
                label="Confirmar contraseña"
                name="confirmarPass"
                value={data.confirmarPass}
                onChange={cambiar}
              />
              <FormHelperText error={isEmpty(error.confirmarPass) ? false : true}>
                {!isEmpty(error.confirmarPass) && error.confirmarPass}
              </FormHelperText>
            </FormControl>
          </Grid>
          <Grid size={12}>
            <FormControl
              error={isEmpty(error.terminos) && isEmpty(error.politicas) ? false : true}
            >
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      sx={{ color: "#D8DADC" }}
                      name="terminos"
                      color="primary"
                      value={aceptarTerms}
                      onChange={(e) => setAceptarTerms(e.target.checked)}
                    />
                  }
                  label={
                    <span>
                      Acepto <Link to={'/'}>términos y condiciones</Link>
                    </span>
                  }
                  required={true}
                />
                <FormControlLabel
                  required
                  control={
                    <Checkbox
                      sx={{ color: "#D8DADC" }}
                      name="politica"
                      color="primary"
                      value={aceptarTerms}
                      onChange={(e) => setAceptarPolit(e.target.checked)}
                    />
                  }
                  label={
                    <span>
                      He leído la <Link to={'/'}>política de privacidad</Link>
                    </span>
                  }
                />
                <FormHelperText>
                  {
                    (!isEmpty(error.terminos) || !isEmpty(error.politicas)) &&
                    error.terminos + ' ' + error.politicas
                  }
                </FormHelperText>
              </FormGroup>
            </FormControl>
          </Grid>
        </Grid>
        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          disabled={disable}
          sx={{ mb: 1 }}
        >
          Siguiente
        </Button>
        <Typography component="p" align='center' sx={{ mb: 1, mt: 1 }}>
          Ingresar <Link href='/'>aquí</Link>
        </Typography>
      </form>
    </Grid>
  );
}

export default SignUp;